// extracted by mini-css-extract-plugin
module.exports = {"profile-icon-root":"Profile_profile-icon-root__39tkU","placeholder":"Profile_placeholder__1FPsd","menu-dropdown-root":"Profile_menu-dropdown-root__3bhVj"};